export const graphCNCConfig = [
  {
    id: 1,
    graph_label: "On / Off /Idle",
    fields: [
      {
        id: 25,
        label: "On Time",
        meta: [],
        required: true,
      },
      {
        id: 26,
        label: "Off Time",
        meta: [],
        required: true,
      },
      {
        id: 27,
        label: "Idle Time",
        meta: [],
        required: true,
      },
    ],
  },
  {
    graph_label: "Count",
    id: 2,
    fields: [
      {
        id: 28,
        label: "Count",
        required: true,
        meta: [
          {
            label: "Expected count",
            type: "number",
            key: "expected_count",
            placeholder: "Enter Counts",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    graph_label: "Average Machining Time",
    fields: [
      {
        id: 29,
        label: "Machining Time",
        required: true,
        meta: [],
      },
    ],
  },
  {
    id: 4,
    graph_label: "Average Non-Machining Time",
    fields: [
      {
        id: 30,
        label: "Non-Machining Time",
        required: true,
        meta: [],
      },
    ],
  },
  {
    id: 5,
    graph_label: "Power consumption",
    fields: [
      {
        id: 31,
        label: "Kwh",
        required: false,
        meta: [],
      },
    ],
  },
  {
    id: 6,
    graph_label: "Status",
    fields: [
      {
        id: 32,
        label: "Machine Status",
        required: true,
        meta: [],
      },
      {
        id: 33,
        label: "Supply Status",
        required: false,
        meta: [],
      },
    ],
  },
];
